import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Container, Header, Segment } from "semantic-ui-react";
import { Link } from "react-router-dom";

@observer
class NotFoundPage extends Component {
  render() {
    const { helpText, continueLinkUrl, continueLinkText, setNotFoundRedirect } = this.props;

    const url = window.location.pathname;

    const splitUrl = url.split("/");

    splitUrl.splice(0, 4);

    let newLinkUrl = continueLinkUrl;

    splitUrl.forEach(() => {
      newLinkUrl = `../${newLinkUrl}`;
    });

    return (
      <div style={{ background: "white", paddingBottom: "50px" }}>
        <Container>
          <Segment basic>
            <Segment placeholder>
              <Header icon className="ui huge text">
                404 Not Found
              </Header>
              <p style={{ textAlign: "center" }}>{helpText}</p>
              <p style={{ textAlign: "center" }}>
                Return to{" "}
                <Link to={newLinkUrl} onClick={setNotFoundRedirect}>
                  {continueLinkText}
                </Link>
              </p>
            </Segment>
          </Segment>
        </Container>
      </div>
    );
  }
}
NotFoundPage.defaultProps = {
  helpText: "Sorry, the page you were looking for could not be found.",
  continueLinkUrl: "tours",
  continueLinkText: "My Tours",
};
NotFoundPage.propTypes = {
  helpText: PropTypes.string,
  continueLinkUrl: PropTypes.string,
  continueLinkText: PropTypes.string,
  setNotFoundRedirect: PropTypes.func,
};
export default NotFoundPage;
